<template>
    <v-row v-if="!$store.getters.progress" style="height: max-content" class="ma-0 pb-offset pt-4">
        <v-col cols="12" class="pa-1">
            <v-card class="pa-0 background-2 round-card" :class="{'elevation-0': inDialog}">
                <v-card-title v-if="!inDialog" class="pa-3">
				    <p class="pl-3">{{ editTitleDialog }}</p>
                    <v-spacer></v-spacer>
                </v-card-title>
                <v-divider v-if="!inDialog"></v-divider>
                <v-container fluid :class="{'px-3': $vuetify.breakpoint.mdAndUp, 'px-0': $vuetify.breakpoint.smAndDown}" class="mt-2">
                    <fields-generator
                        :fieldsset.sync="fieldsset"
                        :model="model"
                        ref="fieldsgenerator"
                        :selectChange="onChange"
                        :support="support"
                    ></fields-generator>
                    <small class="px-6">* Indica i campi obbligatori</small>
                </v-container>

                <checklist-task v-if="checklistTask"
                    :model="model"
                ></checklist-task>
            </v-card>
        </v-col>

        <v-col class="pa-1 pt-4" cols="12" v-if="load && crudRelation">
            <crud-table-relationship
                ref="crudTableRelationship"
                :info-url="crudRelation.infoUrl"
                :children="relationModels"
                :parent="model"
                :filter="crudRelation.filter"
                :footer-component="footerComponent"
                :in-dialog="inDialog"
                :totals-config="fieldsset.totals_config"
                :show-history-button="showHistoryDrawer"
                @open-history="openHistoryDrawer"
            ></crud-table-relationship>
        </v-col>

        <v-col cols="12" class="pt-3 px-1" v-if="crud">
            <crud
                :title='crud.title'
                :action-icon='crud.icon'
                :model-def='crud.modelDef'
                :model-def-info='crud.modelDefInfo'
                :sub-filters="{[crud.id_key]: id}"
                action-position='absolute'
                :default-input="{[crud.id_key]: id}"
                :positionLeft="true"
                :positionRight="false"
                direction="right"
                :crud-dialog="crud.crudDialog"
            ></crud>
        </v-col>

        <v-col cols="12" class="pt-4 pa-0" v-if="fileUpload">
            <file-uploader
                :id="id"
                :attachable-type="fileUpload.attachableType"
            ></file-uploader>
        </v-col>

        <v-tooltip top>
			<template v-slot:activator="{ on: tooltip }">
				<v-fab-transition>
                    <v-btn
                        v-on="{ ...tooltip }"
                        @click.native="updateModel()"
                        :loading="saved"
                        color="primary"
                        dark
                        fixed
                        bottom
                        right
                        fab
                        :style="historyFabOffset"
                        :disabled="disabledUpdate">
                        <v-icon>mdi-sync</v-icon>
                    </v-btn>
                </v-fab-transition>
            </template>
            <span>Aggiorna</span>
        </v-tooltip>
		<confirm-dialog
			:confirmModel="confirmExit"
			:mainTitle="$trans('save_primary_message')"
			:secondTitle="$trans('save_secondary_message')"
			@update:confirmModel="confirmExit = false"
            :exit="{label:'Esci', color:'error'}"
			:atConfirm="updateModel"
			:atExit="exit"
		></confirm-dialog>

		<confirm-dialog
			:confirmModel="confirmDeadlinesRegenerate"
			mainTitle="Le scadenze di questo documento sono state modificate a mano"
			secondTitle="Cambiando condizione di pagamento o data verranno ricreate: i pagamenti che non rientrano nelle nuove rate saranno sganciati."
			@update:confirmModel="confirmDeadlinesRegenerate = false"
			:atConfirm="confirmDeadlinesRegenerateAndSave"
			:confirm="{color: 'warning', label: 'ricrea e salva'}"
		></confirm-dialog>

		<!-- Chronology Warning Dialog -->
		<chronology-warning-dialog
			v-if="isChronologyEnabled"
			:dialog.sync="chronologyDialog"
			:conflicts="chronologyConflicts"
			@confirm="handleChronologyConfirm"
			@cancel="handleChronologyCancel"
		></chronology-warning-dialog>

        <v-dialog v-model="lockDialog" max-width="600" persistent>
            <v-card class="background-2 round-card">
                <v-card-title primary-title class="subtitle-1 background-2" v-if="lockTitle">{{ lockTitle }}</v-card-title>
                <v-divider></v-divider>
                <v-card-text style="min-height: 100px;" class="pt-4 body-2">{{ lockMessage }}</v-card-text>
                <v-divider></v-divider>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn text color="primary" @click.native.stop="lockDialog = false">CHIUDI
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <!-- Storico prodotti ordinati dal cliente (solo ordini di vendita) -->
        <saleorder-products-history-drawer
            v-if="showHistoryDrawer && historyDrawerOpen"
            :company-id="model.company_id"
            :items="relationModels"
            :add-handler="addProductFromHistory"
            @close="historyDrawerOpen = false"
        ></saleorder-products-history-drawer>
    </v-row>
</template>

<script>
    import Vue from 'vue'
    import FormsMixin from '@/mixins/FormsMixin'
    import documentNumberingValidation from '@/mixins/documentNumberingValidation'
    import ChecklistTask from '@/components/common/ChecklistTask'
    import FileUploader from '@/components/common/FileUploader.vue'
    import CrudTableRelationship from '@/components/common/CrudTableRelationship'
    import ChronologyWarningDialog from '@/components/common/ChronologyWarningDialog'
    import SaleorderProductsHistoryDrawer from '@/components/modules/orders/SaleorderProductsHistoryDrawer'

    export default {
        name: 'edit',
        mixins: [FormsMixin, documentNumberingValidation],
        components: {
            FileUploader,
            ChecklistTask,
            CrudTableRelationship,
            ChronologyWarningDialog,
            SaleorderProductsHistoryDrawer,
        },
        props: {
            id: Number,
            modelDef: String,
            redirect: Object,
            urlAppend: {
                type: String,
                default: ''
            },
            queryParams: {
                type: String,
                default: ''
            },
            footerComponent: String,
            inDialog: {
                type: Boolean,
                default: false
            }
        },

        data() {
            return {
                url: '',
                model: {},
                items: {},
                next: null,
                support: {},
                load: false,
                crud: false,
                saved: false,
                historyDrawerOpen: false,
                fieldsset: {},
                component: {},
                changed: false,
                fileUpload: null,
                crudRelation: null,
                relationModels: [],
                confirmExit: false,
                checklistTask: null,
                originalUpdateValue: null,
                lockDialog: false,
                lockTitle: null,
                lockMessage: '',
                originalDeadlineKeys: {},
                confirmDeadlinesRegenerate: false,
                deadlinesRegenerateConfirmed: false,
            }
        },

        beforeRouteLeave(to, from, next) {
            if(this.$store.getters.modelEdited) {
                this.confirmExit = true
                this.next = next
            } else {
                next()
            }
        },

        watch: {
            modelForWatcher: {
                handler(newVal, oldVal) {
                    if(!_.isEmpty(oldVal) && !this.$store.getters.progress && (JSON.stringify(newVal) !== JSON.stringify(this.oldVal))) {
                        this.$store.commit('setModelEdited', true)
                    }
                },
                deep: true,
            },
        },
        
        created() {

            let urlWithAppend = this.urlAppend != '' ? '/' + this.urlAppend : ''
            let queryString = this.queryParams != '' ? '?' + this.queryParams : ''
            this.axios.get(this.modelDef + urlWithAppend + '/' + this.id + '/edit' + queryString).then(response => {
                // get body data
                this.model = response.data.model
                this.fieldsset = response.data.fields
                this.crudRelation = response.data.fields.crudRelation
                this.crud = response.data.fields.crud
                this.fileUpload = response.data.fields.fileUpload
                this.checklistTask = response.data.fields.checklistTask
                this.component = response.data.fields.component

                if(this.crudRelation) {
                    _.forEach(response.data.model[this.crudRelation.relationModelsKey], (value, key) => {
                        Vue.set(this.relationModels, key, value)
                    })
                }

                _.forEach(this.fieldsset.fields, (value, key) => {
                    if((value.type === 'checkbox' || value.type === '') && this.model[value.key] === undefined) {
                        Vue.set(this.model, value.key, '')
                    }
                })

                if(response.data.fields.disabledUpdateKey !== undefined) {
                    this.originalUpdateValue = this.model[response.data.fields.disabledUpdateKey]
                }

                this.originalDeadlineKeys = {
                    payment_term: this.model.payment_term,
                    date: this.model.date
                }

                this.$store.commit('endProgress')
                this.load = true
            
            }, response => {
                    // error callback
            })
        },

        beforeDestroy() {
            this.$store.commit('setModelEdited', false)
	    },

        computed: {
            // Drawer storico prodotti: solo ordini di vendita, con cliente selezionato
            showHistoryDrawer() {
                return this.modelDef === 'saleorders' && this.load && !!this.crudRelation && !this.inDialog && !!this.model.company_id
            },

            // Su desktop il drawer (permanent, 400px) coprirebbe il FAB: lo sposto a sinistra
            historyFabOffset() {
                if(this.showHistoryDrawer && this.historyDrawerOpen && this.$vuetify.breakpoint.mdAndUp) {
                    return {right: '416px'}
                }
                return {}
            },

            editTitleDialog() {
                if(this.fieldsset.model_name)
                    return 'Modifica '+ Vue.trans(this.fieldsset.model_name)
                else return 'Modifica'
            },

            modelForWatcher() {
                return _.cloneDeep(this.model);
            },

            disabledUpdate() {
                if(this.originalUpdateValue === undefined) {
                    return false
                } else if(this.originalUpdateValue == true) {
                    return true
                } else {
                    return false
                }
            },

            isChronologyEnabled() {
                // Extract model type from modelDef
                const modelType = this.extractModelType(this.modelDef)

                if (!modelType) {
                    return false
                }

                // Check if chronology check is enabled for this model type from settings
                const isEnabled = this.$store.getters.getSettingByModel(modelType, 'enable_cronology_check')

                return isEnabled === true || isEnabled === 'true' || isEnabled === 1
            }
        },

        methods: {
            exit() {
                this.$store.commit('setModelEdited', false)
                this.next()
            },

            // Aggiunta rapida dal drawer "Storico prodotti" (ordini di vendita)
            addProductFromHistory(productId, quantity) {
                if(!this.$refs.crudTableRelationship) {
                    return Promise.resolve(false)
                }
                return this.$refs.crudTableRelationship.addProductFromHistory(productId, quantity)
            },

            openHistoryDrawer() {
                this.historyDrawerOpen = true
            },

            // Call at change select option
            onChange(field, event) {
                Promise.all(this.$eventBusUtility.fieldsGeneratorConditions(field, event, this.fieldsset, this.model, this.support)).then((responses) => {
                    responses.forEach(response => {
                        if(this.model[response.key]) {
                            this.$refs.fieldsgenerator.$refs[response.key][0].$emit('change', this.model[response.key])
                        }
                    })
                })
            },

            sendModel() {
                this.saved = true
                let urlWithAppend = this.urlAppend != '' ? '/' + this.urlAppend : ''
                let queryString = this.queryParams != '' ? '?' + this.queryParams : ''
                this.axios.put(this.modelDef + urlWithAppend + '/' + this.id + queryString, this.model).then(response => {
                    // get body data
                    this.saved = false
                    this.deadlinesRegenerateConfirmed = false
                    //this.model = {}
                    this.$store.commit('setModelEdited', false)

                    // Riallinea il riferimento con cui updateModel() rileva la modifica
                    // di condizione/data: senza questo un secondo salvataggio senza
                    // ulteriori modifiche riapre il dialog di conferma rigenerazione rate.
                    this.originalDeadlineKeys = {
                        payment_term: this.model.payment_term,
                        date: this.model.date
                    }

                    const detached = (response.data && response.data.detached_payments) || []
                    if(detached.length > 0) {
                        this.$store.commit('setSnackbar', {
                            timeout: 10000,
                            text: detached.length + ' pagamenti sganciati dalle scadenze: il residuo è da riallocare dall\'editor pagamenti',
                            value: true,
                            color: 'warning'
                        })
                    }

                    // Emit event for document numbering gaps update
                    this.$eventBusUtility.$emit('documentUpdated', {
                        modelDef: this.modelDef,
                        id: this.id,
                        model: this.model
                    })

                    // Got in show
                    if(this.next != null) {
                        this.next()
                    } else {
                        this.$eventBusUtility.chooseRedirect(this.$router, response, this.redirect, this.modelDef)
                    }
                }, response => {
                    // error callback
                    this.saved = false
                    this.deadlinesRegenerateConfirmed = false
                })
            },

            confirmDeadlinesRegenerateAndSave() {
                this.confirmDeadlinesRegenerate = false
                this.deadlinesRegenerateConfirmed = true
                this.updateModel()
            },

            updateModel() {
                // Pulsante bloccato dal primo clic: i controlli prima del salvataggio (lettere d'intento,
                // cronologia) chiamano il server, e ogni clic dato nell'attesa mandava un salvataggio in più
                if (this.saved) return
                this.saved = true
                this.confirmExit = false
                this.$refs.fieldsgenerator.$validator.validateAll().then(result => {
                    if (!result) {
                        this.saved = false
                        this.$emit('validation-failed')
                        return this.handleValidationErrorAdvanced()
                    }

                    if(typeof this.$refs.fieldsgenerator.$refs.signaturePad !== 'undefined') {
                        this.model.signature = this.$refs.fieldsgenerator.$refs.signaturePad[0].saveSignature().data
                    }
                    
                    if(this.crudRelation) {
                        this.model[this.crudRelation.relationModelsKey] = this.relationModels.map(({ subtotal, ...rest }) => rest)
                    }

                    if(this.model.deadlines_modified && this.originalDeadlineKeys && (
                        this.model.payment_term !== this.originalDeadlineKeys.payment_term ||
                        this.model.date !== this.originalDeadlineKeys.date
                    ) && !this.deadlinesRegenerateConfirmed) {
                        // il salvataggio riparte dalla conferma del dialog: va sbloccato
                        this.saved = false
                        this.confirmDeadlinesRegenerate = true
                        return
                    }

                    // Check chronology before proceeding
                    const proceedWithSave = () => {
                        if(typeof this.fieldsset.checkBeforeSave !== 'undefined' && (typeof this.fieldsset.checkBeforeSave['settings'] == 'undefined' || this.$store.getters.checkSettings(this.fieldsset.checkBeforeSave['settings']))) {
                            this.axios.post(this.fieldsset.checkBeforeSave['url'], this.model).then(response => {
                                // get body data
                                if(response.data.success) {
                                    this.sendModel()
                                } else {
                                    this.saved = false
                                    this.lockTitle = typeof response.data.title != 'undefined' ? response.data.title : null
                                    this.lockMessage = response.data.message
                                    this.lockDialog = true
                                }
                            }, () => {
                                this.saved = false
                            })
                        } else {
                            this.sendModel()
                        }
                    }

                    // Check chronology (from mixin)
                    this.checkChronologyBeforeSave(proceedWithSave)

                }).catch(() => {
                    this.saved = false
                })
            },
        },
    }
</script>
